package one.healthium.today.di

import one.healthium.today.ui.TodayViewModel
import org.koin.core.module.dsl.viewModelOf
import org.koin.dsl.module
import one.healthium.today.ui.period_tracker.PeriodTrackerViewModel

val todayModule = module {
    viewModelOf(::TodayViewModel)
    viewModelOf(::PeriodTrackerViewModel)
}